document.addEventListener('algolia.hooks.initialize', function() {

algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString',

function(defaultFilter) {

if (defaultFilter && defaultFilter.includes("collection_ids")) {

const collectionIDFilterRegex = /collection_ids:"\w+"/g;

const matches = window.location.pathname.match(

/\/collections\/([^/]+)/i

);


const collectionHandle = (matches && matches.length === 2) ? matches[1] : null;


if (collectionHandle) {

return defaultFilter.replace(

collectionIDFilterRegex, "collections:" + collectionHandle

);

}

}

return defaultFilter;

}

);

});